import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import { FormlyField, FormlyFieldConfig } from "@ngx-formly/core";
import { Observable, debounceTime, of, switchMap, tap } from "rxjs";

export function EmailAsyncValidator(control: AbstractControl): Observable<ValidationErrors | null> {
  if (!control.value) {
    return of(null);
  }

  return of(control.value).pipe(
    debounceTime(500),
    switchMap(value => {
      // Simula una chiamata di convalida dell'email, sostituisci con la tua logica di convalida
      const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

      return of(isValidEmail ? null : { invalidEmail: true });
    })
  );
}

export function RequireMatchValidators(control: AbstractControl, field: FormlyFieldConfig) {

  if (!field.options.formState.editMode) return null

  const selection: any = control.value;
  if (typeof selection === "string") {
    return { match: true };
  }
  return null;
}

export function AutocompleteMatchValidators(control: AbstractControl, field: FormlyFieldConfig) {

  if (!field.options.formState.editMode) return null

  const selection: any = control.value;
  if (typeof selection === "string") {
    return { AutocompleteMatch: true };
  }
  return null;
}


export function RequireMatchMessage(error: any, field: FormlyFieldConfig) {
  return `"${field.formControl.value} "indirizzo non valido!`;
}

export function EmailValidators(control: AbstractControl): ValidationErrors {
  if (control.value) {
    return /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@[a-z0-9](?:[a-z0-9-]*[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)+$/i
    .test(control.value) ? null : { email: true };
  }
}

export function EmailValidatorMessage(error: any, field: FormlyFieldConfig) {
  return `"${field.formControl.value} "indirizzo non valido!`;
}


export function PivaValidators(control: AbstractControl): ValidationErrors {

  if(control.value){
  return /^[0-9]{11}$/
    .test(control.value) ? null : { p_iva: true };
  }
}

export function PivaValidatorMessage(error: any, field: FormlyFieldConfig) {
  return `"${field.formControl.value}" partita iva non valida!`;
}


export function CfValidators(control: AbstractControl): ValidationErrors {
  if (control.value) {
    return /^[A-Za-z]{6}[0-9]{2}[A-Za-z]{1}[0-9]{2}[A-Za-z]{1}[0-9]{3}[A-Za-z]{1}$/i
      .test(control.value) ? null : { cf: true };
  }
}

export function CfValidatorMessage(error: any, field: FormlyFieldConfig) {
  return `"${field.formControl.value}"codice fiscale non valido!`;
}


export function PhoneValidators(control: AbstractControl): ValidationErrors {
  return /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{3})(?: *x(\d+))?\s*$/
    .test(control.value) ? null : { phone: true };
}

export function PhoneValidatorMessage(error: any, field: FormlyFieldConfig) {
  return `"${field.formControl.value} "numero di telefono non valido!`;
}

export function CapValidators(control: AbstractControl): ValidationErrors {
  return /^[0-9]{5}$/
    .test(control.value) ? null : { cap: true };
}

export function CapValidatorMessage(error: any, field: FormlyFieldConfig) {
  return `"${field.formControl.value}"cap non valido!`;
}

export function minLengthValidationMessage(error: any, field: FormlyFieldConfig) {
  return `Deve avere almeno ${field.props.minLength} caratteri`;
}

export function maxLengthValidationMessage(error: any, field: FormlyFieldConfig) {
  return `Questo valore deve inferiore a ${field.props.maxLength} caratteri`;
}

export function minValidationMessage(error: any, field: FormlyFieldConfig) {
  return `Questo valore deve essere maggiore di ${field.props.min}`;
}

export function maxValidationMessage(error: any, field: FormlyFieldConfig) {
  return `Questo valore deve inferiore a ${field.props.max}`;
}

export function minLengthValidationMessages(error: any, field: FormlyFieldConfig) {
  return `Should have atleast ${field.props.minLength} characters`;
}


//CREARE LA CLASSE PER USARE LA VALIDAZIONE
export function UploadValidator(
  control: AbstractControl,
  field: FormlyFieldConfig,
  options: any = {}
): ValidationErrors {

  //console.log(field)
  //console.log(control)

  if (field.props.count == 0)
    return { 'mat-upload': { message: `Campo obbligatorio` } }

}

export function atLeastOneElement(control: AbstractControl): ValidationErrors | null {
    return Array.isArray(control.value) && control.value.length > 0 ? null : { atLeastOne: true };
}

export const atLeastOneCheckboxChecked: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const alimentari = control.get('jd.alimentari')?.value;
  const noAlimentari = control.get('jd.no_alimentari')?.value;
  return alimentari || noAlimentari ? null : { atLeastOneRequired: true };
};

export const atLeastOneCheckboxCheckedEmporio: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {

  const d1 = control.parent.controls["d1"].value
  const d2 = control.parent.controls["d2"].value
  const d3 = control.parent.controls["d3"].value
  const d4 = control.parent.controls["d4"].value
  const d5 = control.parent.controls["d5"].value
  const d6 = control.parent.controls["d6"].value
  const d7 = control.parent.controls["d7"].value
  const d8 = control.parent.controls["d8"].value

  return (d1||d2||d3||d4||d5||d6||d7||d8) ? null : { atLeastOneCheckbox: true }


};



export const atLeastOne: ValidatorFn = (control: AbstractControl, field={},  options:any={}): ValidationErrors | null => {


    //errorPath è uno dei campi su quale fare il confronto e anche quello su quale visualizzare il messaggio
  const v1 = eval("control.value?."+options["errorPath"]);
  const v2 = eval("control.value?."+options["item1"]);

  if (v1 || v2){
    return null
  }

  return { atLeastOneValidator: { message: options["message"]} };

};





export const dateRange: ValidatorFn = (control: AbstractControl, field={},  options:any={}): ValidationErrors | null => {

    //errorPath il campo su quale visualizzare il messaggio (quindi li ci va field.key che contiene jd.)
    const start = eval("control.value?." + options.start);
    const end = eval("control.value?." + options.end);

    const data_inizio = new Date(start)
    const data_fine = new Date(end)

    if (data_inizio <= data_fine){
      return null
    }

    return { dateRangeValidator: { message: options.message} };

  };



export function UploadValidatorMessage(error: any, field: FormlyFieldConfig) {
  return `mancano i file allegati`;
}


export function fieldMatchValidator(control: AbstractControl) {

  console.log(control)

  const { password, passwordConfirm } = control.value;

  // avoid displaying the message error when values are empty
  if (!passwordConfirm || !password) {
    return null;
  }

  if (passwordConfirm === password) {
    return null;
  }

  return { fieldMatch: { message: 'Password Not Matching' } };
}

